module.exports = __webpack_public_path__ + "img/icons B_12.46ef6bbd.svg";